export const state = {
  currentSlug: null,
  info: null,
  campaigns: null,
  partnerInfo: null,
  productTypes: null,
  maxPages: null,
  selectedSort: 'age:DESC',
  selectedProductType: '0',
  sortOptions: [
    { value: 'Newest First', key: 'age:DESC' },
    { value: 'Lowest Price First', key: 'selling_price:ASC' },
    { value: 'Highest Price First', key: 'selling_price:DESC' },
    { value: 'Best Selling', key: 'orders:DESC' },
  ],
  showMobileFilterModal: false,
  showMobileSortModal: false,
};

export const mutations = {
  updateCollection(state, response) {
    state.info = response.data;
  },

  updateCollectionCampaigns(state, campaigns) {
    state.campaigns = campaigns;
  },

  setCollectionPartnerInfo(state, partnerInfo) {
    state.partnerInfo = partnerInfo;
  },

  clearCollectionPartnerInfo(state) {
    state.partnerInfo = null;
  },
};